import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  main: {
    zIndex: 1,
    justifyContent: "center",
  },
});
